module.exports = __webpack_public_path__ + "media/fonts/OFN-v2-c273037b3ba3ee8264bc67e31ea3d701.woff";